// extracted by mini-css-extract-plugin
export default {"modalWrapper":"modal_modalWrapper__JoZ0g","modalContentWrapper":"modal_modalContentWrapper__FXChq"};